import { render, staticRenderFns } from "./premium-form-adjust.vue?vue&type=template&id=2b7b7f48&scoped=true&"
import script from "./premium-form-adjust.vue?vue&type=script&lang=js&"
export * from "./premium-form-adjust.vue?vue&type=script&lang=js&"
import style0 from "./premium-form-adjust.vue?vue&type=style&index=0&id=2b7b7f48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7b7f48",
  null
  
)

export default component.exports